<template>
  <div id="popup" :class="RESULTS.length ? 'ol-popup' : ''" >
    <a href="#" id="popup-closer"></a>
    <div id="popup-content">
    <info-query @close="$emit('close')" v-if="RESULTS.length"></info-query>
  </div>
  </div>
</template>

<script>
import InfoQuery from "@/components/SideBar/infoQuery";
import {mapState} from "vuex";

export default {
  name: "PopupInfo",
  components: {InfoQuery},
  computed: {
    ...mapState('featureInfo', {
      RESULTS: 'results',
      LAYER: 'selectedLayer',
      FEATURE: 'selectedFeature',
    }),
  },
  beforeDestroy () {
    this.$store.commit('featureInfo/CLEAR_QUERY');
  },
}
</script>

<style scoped>

</style>
